import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-policy-brief',
  templateUrl: './policy-brief.component.html',
  styleUrls: ['./policy-brief.component.css']
})
export class PolicyBriefComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
